export class SVGConstants {
  public static readonly SVG_NAMESPACE = "http://www.w3.org/2000/svg";
}
